import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimerService {
  startTime = 0;
  isRunning = false;
  timeElapsed = 0;
  stopTime = 0;
  pause = false;
  pTime = 0;

  started: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  stopped: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {

  }

  start(callback: any, stopTime: number) {
    this.isRunning = true;
    this.stopTime = stopTime;
    requestAnimationFrame((prop) => this.loop(callback, prop));
  }

  stop() {
    this.timeElapsed = 0;
    this.stopTime = 0;
    this.isRunning = false;
    this.pause = true;
  }

  private loop(callback, timeStamp) {
    if (this.timeElapsed > this.stopTime) {
      this.stop();
      return callback('stop');
    }
    if (!this.startTime) {
      this.startTime = timeStamp;
    }
    if (this.isRunning && !this.pause) {
      this.timeElapsed = (timeStamp - this.startTime) - this.pTime;
      requestAnimationFrame((prop) => this.loop(callback, prop));
    } else if (this.isRunning && this.pause) {
      this.pTime = (timeStamp - this.startTime) - this.timeElapsed;
      this.timeElapsed = (timeStamp - this.startTime) - this.pTime;
      this.pause = false;
      requestAnimationFrame((prop) => this.loop(callback, prop));
    }
  }
}
